import React from 'react'
import {
    FormCell, CellBody, CellFooter, Switch, Button,
    CellHeader, Label, Input, Toptips, Toast, Dialog, Form, Radio,
} from 'react-weui'
import { WKGreenTitle } from '../../components/wk'
import { WKVisible } from '../../components/wk'


class LectureAuthority extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isChannelNeedMoney: false,
            isResell: false,
            selectedRadio: 'free',
            password: '',
            money: '',
            resellPercent: '',
        }
        this.setField = this.setField.bind(this)
    }
    onChangeRadio(e, value) {
        this.setState({ selectedRadio: value })
    }
    bindValue(e, field) {
        const value = e.target.value
        this.setState({[field]: value})
    }
    setField(field, value) {
        this.setState({[field]: value})
    }
    verify () {
        const reg = /^[0-9]\d*|0$/;

        if (this.state.selectedRadio === 'unfree') {
            const { money, resellPercent } = this.state
            if (!/^(-)?(([1-9]{1}\d*)|([0]{1}))(\.(\d){1,2})?$/.test(money) || money < 0) {
                return {
                    status: false,
                    msg: '请输入正确的价格',
                }
            }
            if (this.state.isResell) {
                if (!/^\d+$/.test(resellPercent) || (resellPercent < 0 || resellPercent > 100)) {
                    return {
                        status: false,
                        msg: '比例为0到100的整数',
                    }
                }
                if (money * resellPercent / 100 < 0.01) {
                    return {
                        status: false,
                        msg: '价格*分成比例必须大于或等于0.01',
                    }
                }
            }
        }
        if (this.state.selectedRadio === 'password') {
            if(!this.state.password.match(reg) || this.state.password.indexOf('.') > -1) return { status: false, msg: '请输入0-9的纯数字作为密码' }
        }
        return { status: true }
    }
    handleAuthoritySubmit() {
        const verifyRes = this.verify()
        if (!verifyRes.status) {
            return this.props.clickHandle.showTips(verifyRes.msg)
        }
        this.props.clickHandle.submit()
    }
    getData() {
        return this.state
    }
    render() {
        return(
            <div className="lecture-basic">
                <div className="lecture-basic-box">
                    <WKGreenTitle title='课程类型' className="wk-green-specials" />
                    <Form className={`noMargin ${this.state.isChannelNeedMoney ? '' : 'margin-bottom'}`} radio>
                        <FormCell className="select-cell" onClick={e => this.onChangeRadio(e, 'free')} >
                            <CellBody>
                                <span className={`weui-icon-checked ${this.state.selectedRadio === 'free' ? "lecture-basic-box__checked" : "lecture-basic-box__unchecked"}`}/>
                                <span className="lecture-basic-box__mode">{this.state.isChannelNeedMoney ? '试听课' : '免费课'}</span>
                            </CellBody>
                        </FormCell>
                        <FormCell className="select-cell" onClick={e => this.onChangeRadio(e, 'unfree')} >
                            <CellBody>
                                <span className={`weui-icon-checked ${this.state.selectedRadio === 'unfree' ? "lecture-basic-box__checked" : "lecture-basic-box__unchecked"}`}/>
                                <span className="lecture-basic-box__mode">付费课</span>
                            </CellBody>
                        </FormCell>
                        <FormCell className="select-cell" onClick={e => this.onChangeRadio(e, 'password')} >
                            <CellBody>
                                <span className={`weui-icon-checked ${this.state.selectedRadio === 'password' ? "lecture-basic-box__checked" : "lecture-basic-box__unchecked"}`}/>
                                <span className="lecture-basic-box__mode">加密课</span>
                            </CellBody>
                            <CellFooter>
                                <span className="lecture-basic-box__ft-text">需要密码才能听课</span>
                            </CellFooter>
                        </FormCell>
                        {
                            this.state.isChannelNeedMoney && <FormCell className="select-cell" onClick={e => this.onChangeRadio(e, 'payChannel')}>
                                <CellBody>
                                    <span className={`weui-icon-checked ${this.state.selectedRadio === 'payChannel' ? "lecture-basic-box__checked" : "lecture-basic-box__unchecked"}`}/>
                                    <span className="lecture-basic-box__mode">必须购买专栏</span>
                                </CellBody>
                            </FormCell>
                        }
                    </Form>
                    <WKVisible create={this.state.isChannelNeedMoney}>
                        <p className="intro">"必须购买专栏"的直播课程没有单课价格，用户购买专栏前不能访问单课介绍页，可以不编辑单课介绍，专注优化专栏介绍页</p>
                    </WKVisible>
                </div>

                <div className="lecture-basic-box">
                    {/* 下面是按需显示的组件 */}
                    <WKVisible className='margin-bottom' show={this.state.selectedRadio === 'password'}>
                        <WKGreenTitle title="密码" className="wk-green-specials" />
                        <Form>
                            <FormCell>
                                <div className="lecture-basic-box__input">
                                    <Input
                                        onChange={e => this.bindValue(e, 'password')}
                                        type="number"
                                        pattern="[0-9]*"
                                        placeholder="设置数字密码"
                                        value={this.state.password}
                                        className='text-left basic-border'
                                    />
                                </div>
                            </FormCell>
                        </Form>
                    </WKVisible>
                    <WKVisible show={this.state.selectedRadio === 'unfree'}>
                        <WKGreenTitle title="价格" className="wk-green-specials" />
                        <Form>
                            <FormCell>
                                <div className="lecture-basic-box__input">
                                    <Input
                                        onChange={e => this.bindValue(e, 'money')}
                                        type="number"
                                        placeholder="价格区间"
                                        value={this.state.money}
                                        className='text-left basic-border'
                                    />
                                </div>
                            </FormCell>
                            <FormCell switch>
                                <CellBody style={{color: '#666'}}>设置邀请奖励</CellBody>
                                <CellFooter>
                                    <Switch
                                        checked={this.state.isResell}
                                        onChange={e => this.setState({ isResell: e.target.checked })}
                                    />
                                </CellFooter>
                            </FormCell>
                            <WKVisible create={this.state.isResell} tag={null}>
                                <FormCell className="form-cell-block" style={{height: "100px"}}>
                                    <p style={{color: '#666', marginBottom: '10px'}}>分成比例（%）</p>
                                    <div className="lecture-basic-box__input">
                                        <Input
                                            className='text-left basic-border'
                                            value={this.state.resellPercent}
                                            onChange={e => this.bindValue(e, 'resellPercent')}
                                            type="number"
                                            pattern='[0-9]*'
                                            placeholder="请输入分成比例"
                                            disabled={!this.state.isResell}
                                        />
                                    </div>
                                </FormCell>
                            </WKVisible>
                        </Form>
                    </WKVisible>
                </div>

                <div className="lecture-basic-btn">
                    <Button type="primary" onClick={() => this.handleAuthoritySubmit()}>确认开课</Button>
                </div>
            </div>
        )
    }
}

export default LectureAuthority


// WEBPACK FOOTER //
// ./src/components/lectureCreate/LectureAuthority.js